<template>
  <div class="index">
    <div style="margin-top: 0px">
      <div>
        <el-table :data="deviceList" stripe height="600" style="width: 100%;line-height: 60px">
          <el-table-column prop="gizUid" label="userId" min-width="23%"></el-table-column>
          <el-table-column prop="provinceId" label="mopenId" min-width="23%"></el-table-column>
          <el-table-column prop="wechatOpenid" label="openId" min-width="23%"
          ></el-table-column>
          <el-table-column prop="createTime" label="time" min-width="20%"
                           :formatter='onlineTimeFormat'></el-table-column>
          <el-table-column prop="nickName" label="nickName" min-width="10%"></el-table-column>
          <el-table-column prop="avatar" label="avatar" min-width="10%"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'devicetotal',

  data() {
    return {
      currentRoutePath: "/product",
      deviceList: []
    }
  },
  methods: {
    onlineTimeFormat(row) {
      const date = new Date(row.createTime);
      const formatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
      console.log(formatted); // 2026-04-18 16:45:25
      return formatted
    },
  },

  //自动触发写入的函数
  mounted: function () {
    this.$axios.get("http://106.52.65.234:8099/userListAll").then(res => {
      console.log("userListAll res:", res);
      this.deviceList = res.data;
    }).catch(err => {
      this.$notify({title: '错误', message: err, type: 'warning'})
      return false
    })
  }

}

</script>

<style>
</style>